export enum PaymentStatusesEnum {
  Success = 'add_money',
  Failed = 'payment_fail',
}
